import React, { useState, useEffect } from 'react'
import {
  getAuthManagerInstance,
  isInternal,
  isLoggedIn,
} from '../../global/authentication/authentication-manager.js'
import {
  CHANGE_PASSWORD_SUCCESS,
  PASSWORD_MODE,
} from '../Login/Helpers/LoginHelper.js'
import ChangePassword from '../Login/Modules/ChangePassword.jsx'
import { useUserIdHook } from '../Register/ForgotPassword/Hooks/UserIdHook.js'
import FormNotification from '../SelfService/FormNotification.jsx'

function MyProfile() {
  const [showChangePasswordForm, setShowChangePasswordForm] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [showInternalMessage, setShowInternalMessage] = useState(false)
  const userIdHook = useUserIdHook()
  const [, setUserId] = userIdHook

  useEffect(() => {
    if (isInternal()) {
      setShowInternalMessage(true)
    }
  }, [])

  useEffect(() => {
    getAuthManagerInstance()
      .getProfileServiceBehaviorSubject()
      .subscribe((profile) => {
        if (profile) {
          setUserId(profile.emailId)
        }
      })
  }, [])

  const handleDisplayChange = (display) => {
    if (display === CHANGE_PASSWORD_SUCCESS) {
      setShowSuccess(true)
      setShowChangePasswordForm(false)
    }
  }

  const onChangeClick = () => {
    setShowChangePasswordForm(true)
  }

  return !isLoggedIn() ? null : (
    <div className="Grid u-paddingBottom5gu u-sizeConstrained u-marginTop8gu">
      <div className="TwoColumnLayout-leftContainer u-md-size3of12 u-lg-size3of12 u-sm-paddingRight0 u-paddingRight3gu ">
        <div className="LeftNav">
          <ul>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- CTINEXT-4699 */}
            <a href="#">
              <li className="u-paddingVert3gu u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0 left-nav-active">
                <span className="u-paddingLeft2gu u-textSecondary">
                  Change Password
                </span>
              </li>
            </a>
          </ul>
        </div>
      </div>
      <div className="TwoColumnLayout-rightContainer u-md-size9of12 u-lg-size9of12">
        <div className="Article-container">
          <div className="Article-section Article-section--withDivider">
            <div className="u-lg-flex u-md-flexCol u-sm-flexCol u-flexAlignItemsBaseline u-marginBottom4gu">
              <div className="Content u-sizeFull">
                <h2>Change Password</h2>
                {showSuccess && (
                  <div className="Notification Notification--withIcon Notification--withTopBorder Notification--confirm u-marginBottom3gu u-animFadeInUp u-boxShadow u-marginBottom3gu">
                    <hr className="Rule u-textColorConfirm" />
                    <div className="Notification-content">
                      <p>You have successfully changed your password.</p>
                    </div>
                  </div>
                )}
                {showInternalMessage && (
                  <FormNotification
                    content='Your password for this site is your SSO and workstation password. Change your password through your Ameriprise workstation login by selecting CTRL+ALT+DEL, and then "Change Password." This will ensure your SSO and workstation passwords will be synchronized.'
                    status="warn"
                  />
                )}
                {showChangePasswordForm && (
                  <ChangePassword
                    handleDisplayChange={handleDisplayChange}
                    changePasswordData={null}
                    passwordMode={PASSWORD_MODE.CHANGE_PASSWORD_LOGGED_IN}
                    loginInputHook={userIdHook}
                  />
                )}
                {!showChangePasswordForm && !showInternalMessage && (
                  <button
                    onClick={onChangeClick}
                    className="Button Button--primary Button--block u-marginBottom4gu"
                  >
                    Change
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MyProfile
